import {BASE_URL} from "../../config/network";

const faceIdAPI = async ({image1, image2, idsfGroupId}) => {
    const URL = `${BASE_URL}/public/face-id`;
    const METHOD = "POST";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const payload = {
        image_1: image1,
        image_2: image2,
    };

    if (idsfGroupId) {
        payload.idsf_group_id = idsfGroupId;
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return await response.json();
};

export {faceIdAPI};
